import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import { OpportunityContractSearchDto } from './opportunity-contract-search-dto';
import {appConfig} from '../app.config';
import {Opportunity} from '../domain/opportunity';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryOpportunityService {

  public  selectedOpportunityChanged: Subject<Opportunity> = new Subject<Opportunity>();

  constructor(private http: HttpClient) {
  }

  public getOpportunityDetails(opportunityId: number): Observable<any> {
    const url = '/api/opportunity?opportunityId=' + opportunityId;
    return this.http.get<any>(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getOpportunityDetails', false))
      );
  }

  public loadOpportunitiesForAutoComplete(searchParam): Observable<any> {
    const url = '/api/opportunities/auto-complete/search?searchParam=' + searchParam ;
    return this.http.get<any>(url,  appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('loadOpportunitiesForAutoComplete', false))
      );
  }

  public loadOpportunitiesBySearchParameters(opportunityContractSearchDto: OpportunityContractSearchDto): Observable<any> {
    const url = '/api/opportunities/search' ;
    return this.http.post<any>(url, opportunityContractSearchDto, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('loadOpportunitiesBySearchParameters', false))
      );
  }

  public loadContractsForAutoComplete(searchParam): Observable<any> {
    const url = '/api/opportunities/contracts/auto-complete/search?searchParam=' + searchParam ;
    return this.http.get<any>(url,  appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('loadContractsForAutoComplete', false))
      );
  }

  public loadContractsBySearchParameters(opportunityContractSearchDto: OpportunityContractSearchDto): Observable<any> {
    const url = '/api/opportunities/contracts/search' ;
    return this.http.post<any>(url, opportunityContractSearchDto, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('loadContractsBySearchParameters', false))
      );
  }
}
